import React from 'react'

import './LayoutCentered.scss'

export default (WrappedComponent) => (props) => 
	<div className="LayoutCentered">
		<div className="inner">
			<WrappedComponent {...props} />
		</div>
	</div>


// WEBPACK FOOTER //
// ./src/components/LayoutCentered/LayoutCentered.jsx